/**
 * Returns a deep copy of a value
 */
export function copy(value: any): any {
  return JSON.parse(JSON.stringify(value));
}
